/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from "react";

import * as S from './styles';

export function SkeletonText({ width, height, color }) {
  return (
    <S.Container
      width={width}
      height={height}
      color={color}
    />
  )
}
